import React, { useEffect, useState } from "react";
import NavBar from "../../Common/NavBar";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { DispositivosURL } from "../../API/apiurls";
import { GrEdit } from "react-icons/gr";
import { BsXCircleFill } from "react-icons/bs";

export function ConfiguracionDispositivos() {
  const navigation = useNavigate();
  const [datos, setDatos] = useState();

  const Listar = async () => {
    try {
      // const response = await axios.get(`${DispositivosURL}${empresaid}`);
      const response = await axios.get(`${DispositivosURL}`);
      setDatos(response.data);
    } catch (error) {
      console.error("Error al listar", error);
    }
  };

  useEffect(() => {
    Listar();
  }, [setDatos]);

  return (
    <div>
      <NavBar />
      <div className="camionesMenu-contenedor">
        <Button className="responsive-back-button" onClick={() => navigation("/dispositivos")}>
          Atras
        </Button>
        <div style={{ width: "100%" }}>Configuracion</div>
        <div>Dispositivos </div>
        <div className="table-responsive">
          <Table  striped bordered hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Codigo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {datos &&
                datos.map((dispositivo) => (
                  <tr key={dispositivo.id}>
                    <td>{dispositivo.id}</td>
                    <td>{dispositivo.nombre}</td>
                    <td>{dispositivo.rutasModel.nombre}</td>
                    <td>
                      <div className="responsive-table-actions">
                        <Button variant="warning" onClick={() => console.log("ds")}>
                          <GrEdit /> Editar
                        </Button>
                        <Button variant="danger" onClick={() => console.log("ds")}>
                          <BsXCircleFill /> Eliminar
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
